<template lang="html">
  <div class="label">
    <strong>{{ qtyLabel }}</strong>
    <span class="is-gray-400"> {{label}}</span>
    <Tooltip
    v-if="tooltipText"
    :tooltipText="tooltipText"/>
  </div>

</template>

<script lang="js">

import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'Label',
  components: {
    Tooltip,
  },
  filters: {
  },
  props: {
    tooltipText: {
      type: String,
    },
    total: {
      type: [String, Number],
    },
    qty: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {
    qtyLabel() {
      return this.qty + ((this.total) ? `/${this.total}` : '');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
